import React, { use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { ReportInfo } from "../../../../../../api/types/svTypes.ts";

export interface ReportContextType {
  copyReports: (ids: string[]) => void;
  deleteReports: (ids: string[]) => void;
  moveReports: (ids: string[], onMoved?: () => void) => void;
  duplicateReport: (report: ReportInfo) => void;
  shareReport: (report: ReportInfo) => void;
  shareReports: (ids: string[], onShared?: () => void) => void;
  generateApiReport?: (report: ReportInfo) => void;
}

export const ReportsManagerContext = React.createContext<ReportContextType | undefined>(undefined);

export const useReportsManagerContext = () => {
  const context = use(ReportsManagerContext);
  return defined(context);
};
